import { useExperimentContext } from './useExperimentContext.js';

function useExperiment() {
    var context = useExperimentContext();
    /**
     * Check if a user is in a specific experiment group.
     *
     * Note! This function requires that you have handled
     * the isLoading state of the experiment service already.
     * Consider wrapping your component in a ExperimentAsyncGuard
     */
    function isInExperimentGroup(_a) {
        var id = _a.id, group = _a.group, type = _a.type;
        if (context.isLoadingExperiments.value || !context.experimentService.value) {
            throw new Error('Experiment service is not initialized yet.');
        }
        var experiments = context.experimentService.value.getExperiments();
        return experiments.some(function (e) {
            var isSameExperiment = e.id === id
                && e.group === group
                && e.status === 'enabled';
            var isValidByType = type ? e.type === type : true;
            return isSameExperiment && isValidByType;
        });
    }
    return {
        service: context.experimentService,
        isLoadingExperiments: context.isLoadingExperiments,
        isInExperimentGroup: isInExperimentGroup,
    };
}

export { useExperiment };
